<template>
  <v-card flat>    
    <v-card flat class="container--fluid">
        <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
          <v-card flat class="v-card__container">
          <h4>{{title}}</h4>
          </v-card>
        </v-card>
    </v-card>
    <AdminProfessions v-if="item=='professions'" />

    <crud-table v-else  :fn="fn" :tableTitle="title" :headersProps="headers" :dfltItem="model" /> 
  </v-card>
</template>

<script>
import crudTable from '@/components/CrudTable/CrudTable'
import AdminProfessions from '@/components/CrudTable/professions/AdminProfessions'
// @group Person
// Applications component
export default {
  name: "Applications",

  components: {
    crudTable,
    AdminProfessions
  },

  props: {
    //has item ,with default string empty
    item: String
  },

  data: () => ({
    fn: null,
    title: null,
    headers: null,
    model: null
  }),

  created() {
    console.log(`AdminTypes - ${this.item}`)

    switch(this.item) {
      case "contracttype":
        this.fn = "ContractTypes"
        this.title = "Avtalstyper"
        this.headers = [
          { text: "Namn", value: "name" },
          { text: "Tillåt lärlingsanmälan", value: "allowNewApprentices", align: 'center', sortable: false },
          { text: "", value: "action", sortable: false }
        ],
        this.model = { 
          name: {
            value: '',
            label: 'Namn',
            type: 'text',
            required: true
          },
          allowNewApprentices: {
            value: false,
            label: 'Tillåt lärlingsanmälan?',
            type: 'boolean'
          }
        }
        break;

      case "professions":
        this.fn = "Professions"
        this.title = "Yrken"
        this.headers = [
          { text: "Namn", value: "name" },
          { text: "Maskinyrke", value: "isMachineProfession", align: 'center', sortable: false},
          { text: "", value: "action", sortable: false }
        ],
        this.model = { 
          name: {
            value: '',
            label: 'Namn',
            type: 'text',
            required: true
          },
          isMachineProfession: {
            value: false,
            label: 'Maskinyrke',
            type: 'boolean'
          }
        }
        break;

      case "employmenttype":
        this.fn = "EmploymentTypes"
        this.title = "Anställningstyp"
        this.headers = [
          { text: "Namn", value: "name" },
          { text: "Tillsvidareanställningstyp", value: "isApprenticeshipEmployment", sortable: false, align: 'center' },
          { text: "", value: "action", sortable: false }
        ],
        this.model = { 
          name: {
            value: '',
            label: 'Namn',
            type: 'text',
            required: true
          },
          isApprenticeshipEmployment: {
            value: false,
            label: 'Tillsvidareanställningstyp?',
            type: 'boolean'
          }
        }
        break;

      case "employmentrole":
        this.fn = "EmploymentRoles"
        this.title = "Anställningsroll"
        this.headers = [
          { text: "Namn", value: "name" },
          { text: "Avser lärlingar", value: "isApprenticeshipEmployment", sortable: false },
          { text: "", value: "action", sortable: false }
        ],
        this.model = { 
          name: {
            value: '',
            label: 'Namn',
            type: 'text',
            required: true
          },
          isApprenticeshipEmployment: {
            value: false,
            label: 'Avser lärlingar?',
            type: 'boolean'
          }
        }
        break;

      default:
        this.$router.go(-1)
    }
  },

  computed: {
  },

  methods: {
  }
};
</script>

<style scoped>
</style>
